var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.reservationDetailsData
    ? _c(
        "div",
        { staticClass: "spa-reservation-details" },
        [
          _c(
            "transition-group",
            { attrs: { name: "expand-y" } },
            [
              _vm.hasCancellationError
                ? _c("SpaStatusMessage", {
                    key: "cancellation-error",
                    attrs: {
                      type: "error",
                      icon: "warning-red",
                      message: _vm.tc(
                        "spaSoft.reservationdetails.cancelPopup.cancelFail",
                        {
                          spaEmail: _vm.propertyData.email,
                          spaPhoneNumber: _vm.propertyData.phone,
                        }
                      ),
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.cancellationMessages, function (message, index) {
                return _c("SpaStatusMessage", {
                  key: index + "-" + message.treatmentName,
                  attrs: {
                    type: "success",
                    icon: "checkmark-green",
                    message: _vm.tc(
                      "spaSoft.reservationdetails.cancelPopup.cancelSuccess",
                      {
                        treatmentName: message.treatmentName,
                      }
                    ),
                  },
                })
              }),
              _vm._v(" "),
              _vm.isReservationCancelled
                ? _c("SpaStatusMessage", {
                    key: "cancellation-confirmation",
                    attrs: {
                      type: "info",
                      icon: "warning",
                      message: _vm.tc(
                        "spaSoft.reservationdetails.cancelDetails.confirmationBanner"
                      ),
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("SpaReservationHeading"),
          _vm._v(" "),
          _c("SpaReservationInfo"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "spa-reservation-details__wrapper container" },
            [
              _c("SpaReservationSummary"),
              _vm._v(" "),
              _c("SpaReservationSidebar"),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }